namespace RioERP.Products {
    export interface ProductTeacherForm {
        RowIds: Serenity.StringEditor;
        TeacherId: Serenity.LookupEditor;
        ESharingType: Serenity.EnumEditor;
        SharingAmount: Serenity.DecimalEditor;
    }

    export class ProductTeacherForm extends Serenity.PrefixedContext {
        static formKey = 'RioERP.ProductsTeacherForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductTeacherForm.init)  {
                ProductTeacherForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.EnumEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(ProductTeacherForm, [
                    'RowIds', w0,
                    'TeacherId', w1,
                    'ESharingType', w2,
                    'SharingAmount', w3
                ]);
            }
        }
    }
}
